import { z } from 'zod';
import { pendingDecisionSchema } from '../autopilot/status.ts';
import { submissionSummarySchema } from './submissions.ts';

/** Strict: unknown keys are rejected so typos never reach the workflow. */
export const submitDecisionRequestSchema = z.strictObject({
  decisionId: z.string().min(1),
  outcome: z.string().min(1),
  reason: z.string().trim().min(1).max(2000),
  payload: z.record(z.string(), z.unknown()).optional(),
});
export type SubmitDecisionRequest = z.infer<typeof submitDecisionRequestSchema>;

export const submitDecisionResponseSchema = z.object({
  accepted: z.boolean(),
  stage: z.string().nullable(),
});
export type SubmitDecisionResponse = z.infer<typeof submitDecisionResponseSchema>;

export const pendingDecisionsItemSchema = submissionSummarySchema.extend({
  pendingDecision: pendingDecisionSchema,
});
export type PendingDecisionsItem = z.infer<typeof pendingDecisionsItemSchema>;
